import { useState, useEffect } from 'react';
import { tenant as tenantApi } from '../services/api';
import { PlanRequerido } from '../services/permisos';

const THEMES = [
  { id: 'dark-tech',      nombre: 'Dark tech',      desc: 'Verde · fondo oscuro · monospace',  btn: 'linear-gradient(135deg,#00e5a0,#00d4e8)', chat: '#0f1517', header: '#141c1e', headerText: '#00e5a0', msgBot: '#141c1e', msgBotText: '#e8f0f1', msgUser: 'rgba(0,229,160,0.1)', msgUserText: '#00e5a0' },
  { id: 'light-minimal',  nombre: 'Light minimal',  desc: 'Índigo · fondo blanco · sans-serif', btn: '#4F46E5',                                chat: '#f8fafc',  header: '#4F46E5',  headerText: '#fff',    msgBot: '#fff',    msgBotText: '#374151', msgUser: '#4F46E5',              msgUserText: '#fff'    },
  { id: 'warm-corporate', nombre: 'Warm corporate', desc: 'Naranja · fondo crema · amigable',   btn: '#FF6B35',                                chat: '#fdf6f0',  header: '#FF6B35',  headerText: '#fff',    msgBot: '#fff',    msgBotText: '#3d2b1f', msgUser: '#FF6B35',              msgUserText: '#fff'    },
  { id: 'elegant-dark',   nombre: 'Elegant dark',   desc: 'Rojo · azul noche · premium',        btn: '#e94560',                                chat: '#16213e',  header: '#0f3460',  headerText: '#e94560', msgBot: '#16213e', msgBotText: '#eaeaea', msgUser: '#e94560',              msgUserText: '#fff'    },
];

function MiniWidget({ theme }) {
  return (
    <div style={{ width: '160px', borderRadius: '8px', overflow: 'hidden', border: `1px solid rgba(255,255,255,0.1)`, fontFamily: 'sans-serif', fontSize: '10px' }}>
      <div style={{ background: theme.header, padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: theme.headerText }}/>
        <span style={{ color: theme.headerText, fontWeight: 600 }}>Asistente</span>
      </div>
      <div style={{ background: theme.chat, padding: '8px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <div style={{ background: theme.msgBot, color: theme.msgBotText, padding: '5px 7px', borderRadius: '6px', maxWidth: '80%' }}>¡Hola! ¿En qué puedo ayudarte?</div>
        <div style={{ background: theme.msgUser, color: theme.msgUserText, padding: '5px 7px', borderRadius: '6px', maxWidth: '70%', alignSelf: 'flex-end' }}>Quiero info</div>
      </div>
    </div>
  );
}

export default function Webhooks({ permisos, onUpgrade }) {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState('');
  const [selectedTheme, setSelectedTheme] = useState('dark-tech');

  useEffect(() => {
    tenantApi.getMe().then(setData);
  }, []);

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(''), 1500);
  };

  const tieneAlgo = permisos?.web || permisos?.whatsapp;

  if (!tieneAlgo) {
    return <PlanRequerido onUpgrade={onUpgrade} />;
  }

  const embedCode = data
    ? `<script\n  src="https://bot.devit.es/widget.js"\n  data-tenant="${data.tenant_id}"\n  data-theme="${selectedTheme}"\n  data-sector="${data.especialidad || 'general'}"\n></script>`
    : '';

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Webhooks</div>
          <div className="page-sub">URLs de integración y widget</div>
        </div>
      </div>

      <div className="content">
        {data?.whatsapp_configurado ? (
          <div className="alert alert-success">
            <span className="alert-icon">✓</span>
            Tu agente está recibiendo mensajes correctamente.
          </div>
        ) : (
          <div className="alert alert-warn">
            <span className="alert-icon">⚠</span>
            Configura tus credenciales de WhatsApp para activar el webhook.
          </div>
        )}

        <div className="webhook-grid">
          {/* WhatsApp */}
          <div className="url-block" style={{opacity: permisos?.whatsapp ? 1 : 0.4, position:'relative'}}>
            {!permisos?.whatsapp && (
              <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.5)',borderRadius:'8px',zIndex:1,fontSize:'12px',color:'var(--text2)',flexDirection:'column',gap:'8px'}}>
                <span>🔒</span>
                <button className="btn btn-ghost" style={{fontSize:'11px',padding:'4px 12px'}} onClick={onUpgrade}>Ver planes</button>
              </div>
            )}
            <div className="url-label">WhatsApp Webhook</div>
            <div className="url-row">
              <span className="url-text">{data?.webhook_whatsapp || 'Cargando...'}</span>
              <button className="copy-btn" onClick={() => copy(data?.webhook_whatsapp, 'wa')}>
                {copied === 'wa' ? '✓' : '⎘'}
              </button>
            </div>
            <div style={{marginTop:'8px', fontSize:'10px', color:'var(--text3)'}}>
              Pega esta URL en Meta → WhatsApp → Webhooks
            </div>
          </div>

          {/* Web widget */}
          <div className="url-block" style={{opacity: permisos?.web ? 1 : 0.4, position:'relative'}}>
            {!permisos?.web && (
              <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.5)',borderRadius:'8px',zIndex:1,fontSize:'12px',color:'var(--text2)',flexDirection:'column',gap:'8px'}}>
                <span>🔒</span>
                <button className="btn btn-ghost" style={{fontSize:'11px',padding:'4px 12px'}} onClick={onUpgrade}>Ver planes</button>
              </div>
            )}
            <div className="url-label">Web Widget Endpoint</div>
            <div className="url-row">
              <span className="url-text">{data?.webhook_web || 'Cargando...'}</span>
              <button className="copy-btn" onClick={() => copy(data?.webhook_web, 'web')}>
                {copied === 'web' ? '✓' : '⎘'}
              </button>
            </div>
            <div style={{marginTop:'8px', fontSize:'10px', color:'var(--text3)'}}>
              Endpoint para el widget de tu web
            </div>
          </div>
        </div>

        {permisos?.whatsapp && (
          <div className="card" style={{marginBottom:'16px'}}>
            <div className="card-title">Token de verificación (WhatsApp)</div>
            <div className="url-row">
              <span className="url-text" style={{color:'var(--amber)'}}>
                {data?.verify_token || 'No configurado — ve a Credenciales'}
              </span>
              {data?.verify_token && (
                <button className="copy-btn" onClick={() => copy(data.verify_token, 'vt')}>
                  {copied === 'vt' ? '✓' : '⎘'}
                </button>
              )}
            </div>
          </div>
        )}
        {permisos?.whatsapp && data?.tenant_id && (
          <>
            <div className="url-block">
              <div className="url-label">Messenger Webhook</div>
              <div className="url-row">
                <span className="url-text">{`https://bot.devit.es/api/meta/messenger/${data.tenant_id}`}</span>
                <button className="copy-btn" onClick={() => copy(`https://bot.devit.es/api/meta/messenger/${data.tenant_id}`, 'ms')}>
                  {copied === 'ms' ? '✓' : '⎘'}
                </button>
              </div>
              <div style={{marginTop:'8px', fontSize:'10px', color:'var(--text3)'}}>
                Pega en Meta → Messenger → Webhooks
              </div>
            </div>
            <div className="url-block">
              <div className="url-label">Instagram Webhook</div>
              <div className="url-row">
                <span className="url-text">{`https://bot.devit.es/api/meta/instagram/${data.tenant_id}`}</span>
                <button className="copy-btn" onClick={() => copy(`https://bot.devit.es/api/meta/instagram/${data.tenant_id}`, 'ig')}>
                  {copied === 'ig' ? '✓' : '⎘'}
                </button>
              </div>
              <div style={{marginTop:'8px', fontSize:'10px', color:'var(--text3)'}}>
                Pega en Meta → Instagram → Webhooks
              </div>
            </div>
          </>
        )}
        {permisos?.web && (
          <div className="card">
            <div className="card-title">Widget flotante — elige tu estilo</div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'12px', margin:'12px 0 20px'}}>
              {THEMES.map(th => (
                <div
                  key={th.id}
                  onClick={() => setSelectedTheme(th.id)}
                  style={{
                    cursor: 'pointer', borderRadius: '8px',
                    border: selectedTheme === th.id ? '2px solid var(--green)' : '1px solid var(--border)',
                    overflow: 'hidden', transition: 'border-color 0.15s'
                  }}
                >
                  <div style={{background: th.chat, padding:'10px', display:'flex', justifyContent:'center'}}>
                    <MiniWidget theme={th}/>
                  </div>
                  <div style={{padding:'8px 10px', background:'var(--bg3)'}}>
                    <div style={{fontSize:'11px', color: selectedTheme === th.id ? 'var(--green)' : 'var(--text)', fontWeight: selectedTheme === th.id ? 500 : 400}}>{th.nombre}</div>
                    <div style={{fontSize:'10px', color:'var(--text3)', marginTop:'2px'}}>{th.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="card-title">Código de embed</div>
            <div style={{
              background:'var(--bg)', border:'1px solid var(--border2)',
              borderRadius:'6px', padding:'12px 14px', fontSize:'11px',
              color:'var(--cyan)', lineHeight:'1.7', whiteSpace:'pre'
            }}>
              {embedCode}
            </div>
            <div style={{marginTop:'10px'}}>
              <button className="btn btn-ghost" style={{fontSize:'11px', padding:'6px 14px'}}
                onClick={() => copy(embedCode, 'embed')}>
                {copied === 'embed' ? '✓ Copiado' : '⎘ Copiar código'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}